import { colorPalette } from './colorPalettes';
import { convertHexToRGBA } from '@/utils/usefulFuncs';

export const APP_COLOR_THEME_NAMES = {
  lightProfessional: 'light-professional',
  darkProfessional: 'dark-professional',
  custom: 'custom',
};

export const COLOR_THEMES = {
  [APP_COLOR_THEME_NAMES.lightProfessional]: {
    header: colorPalette.secondary.white,
    appBackground: colorPalette.primary.oak,
    component: convertHexToRGBA(colorPalette.secondary.white, 0.9),
    componentNoOpacity: colorPalette.secondary.white,
    disabled: convertHexToRGBA(colorPalette.primary.charcoal, 0.05),
    overlay: convertHexToRGBA(colorPalette.primary.charcoal, 0.6),
    border: convertHexToRGBA(colorPalette.primary.charcoal, 0.2),
    lowContrastBorder: convertHexToRGBA(colorPalette.primary.charcoal, 0.05),
    text: colorPalette.primary.charcoal,
    secondaryText: convertHexToRGBA(colorPalette.primary.charcoal, 0.3),
    buttonText: colorPalette.secondary.white,
    proColor: colorPalette.secondary.brightGreen,
    conColor: colorPalette.secondary.brightRed,
    neutral: colorPalette.secondary.lightCharcoal,
    negative: colorPalette.secondary.red,
    positive: colorPalette.secondary.brightGreen,
    inputBg: 'transparent',
    avatarBackgroundColor: colorPalette.secondary.purple,
    buttonColor: colorPalette.primary.charcoal,
    primaryCtaButton: colorPalette.primary.charcoal,
    primaryEyeCatchingCtaButton: colorPalette.secondary.lightBlue,
    badge: colorPalette.secondary.purple,
    error: colorPalette.secondary.red,
    warning: colorPalette.secondary.orange,
    hoverComponentBackground: convertHexToRGBA(colorPalette.secondary.purple, 0.1),
  },
  [APP_COLOR_THEME_NAMES.darkProfessional]: {
    header: colorPalette.primary.charcoal,
    appBackground: colorPalette.primary.charcoal,
    component: colorPalette.secondary.lightCharcoal,
    componentNoOpacity: convertHexToRGBA(colorPalette.secondary.lightCharcoal, 1),
    disabled: convertHexToRGBA(colorPalette.secondary.white, 0.05),
    overlay: convertHexToRGBA(colorPalette.secondary.white, 0.4),
    border: convertHexToRGBA(colorPalette.secondary.white, 0.2),
    lowContrastBorder: convertHexToRGBA(colorPalette.secondary.white, 0.05),
    text: colorPalette.secondary.white,
    secondaryText: convertHexToRGBA(colorPalette.secondary.white, 0.4),
    buttonText: colorPalette.primary.charcoal,
    proColor: colorPalette.secondary.brightGreen,
    conColor: colorPalette.secondary.red,
    neutral: colorPalette.secondary.white,
    negative: colorPalette.secondary.red,
    positive: colorPalette.secondary.brightGreen,
    inputBg: 'transparent',
    badge: colorPalette.secondary.yellow,
    avatarBackgroundColor: colorPalette.secondary.yellow,
    buttonColor: colorPalette.secondary.yellow,
    primaryCtaButton: colorPalette.secondary.yellow,
    primaryEyeCatchingCtaButton: colorPalette.secondary.lightBlue,
    error: colorPalette.secondary.red,
    warning: colorPalette.secondary.orange,
    hoverComponentBackground: convertHexToRGBA(colorPalette.secondary.yellow, 0.1),
  },
};

export const DEFAULT_COLOR_THEME = APP_COLOR_THEME_NAMES.lightProfessional;
